// .env configuration
export const APP_URL = process.env.REACT_APP_API_URL;
